import React, { useState, useRef, useEffect } from "react";
import "../../styles/Navbar.css";
import logo from "../../assets/School_Logo_NoBackground.webp";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const hamburgerRef = useRef(null);

  const toggleMenu = () => setIsOpen((prev) => !prev);
  const closeMenu = () => setIsOpen(false);

  // Attach outside-click listener ONLY when menu is open
  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (e) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        !hamburgerRef.current.contains(e.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  return (
    <nav className="navbar">
      {/* Left section */}
      <div className="nav-left">
        <img
          src={logo}
          alt="Priyadharshinie Public School Logo"
          className="nav-logo-img"
          width="55"
          height="55"
          decoding="async"
        />
        <span className="nav-school-name">PRIYADHARSHINIE PUBLIC SCHOOL</span>
      </div>

      {/* MENU PANEL */}
      <ul ref={menuRef} className={`nav-links ${isOpen ? "active" : ""}`}>
        <li>
          <a href="/" onClick={closeMenu}>
            Home
          </a>
        </li>
        <li>
          <a href="/about" onClick={closeMenu}>
            About
          </a>
        </li>
        <li>
          <a href="/academics" onClick={closeMenu}>
            Academics
          </a>
        </li>
        <li>
          <a href="/admission" onClick={closeMenu}>
            Admissions
          </a>
        </li>
        <li>
          <a href="/gallery" onClick={closeMenu}>
            Gallery
          </a>
        </li>
        <li>
          <a href="/contact-us" onClick={closeMenu}>
            Contact
          </a>
        </li>
      </ul>

      {/* HAMBURGER */}
      <button
        ref={hamburgerRef}
        className={`hamburger ${isOpen ? "active" : ""}`}
        onClick={toggleMenu}
        aria-label="Toggle navigation menu"
        aria-expanded={isOpen}
        type="button"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </nav>
  );
}

export default Navbar;
